export default __webpack_public_path__ + "static/media/star.3ced220b.svg";